import { createPopper } from "@popperjs/core";
import { PopperOptions_$ctor, PopperOptions__withPlacement_Z2582A330, PopperModifier_$ctor, PopperModifier__withName_Z721C83C5, PopperModifier__withOptions_4E60E31B, PopperOptions__withAddedModifier_174A2785, PopperOptions__Finalize } from "./fable_modules/Fable.PopperJS.1.0.0/CreatePopper.fs.js";
import { ofArray } from "./fable_modules/fable-library.3.7.1/List.js";
import { useFeliz_React__React_useState_Static_1505 } from "./fable_modules/Feliz.1.58.1/React.fs.js";
import { usePopper } from "react-popper";
import { value as value_20, some } from "./fable_modules/fable-library.3.7.1/Option.js";
import { createElement } from "react";
import { createObj } from "./fable_modules/fable-library.3.7.1/Util.js";
import { empty, collect, singleton, append, delay, toList } from "./fable_modules/fable-library.3.7.1/Seq.js";
import { Interop_reactApi } from "./fable_modules/Feliz.1.58.1/Interop.fs.js";
import { render } from "react-dom";
import "./styles.css";


export const popcorn = document.querySelector("#popcorn");

export const tooltip = document.querySelector("#tooltip");

export const settingsjs = {
    placement: "bottom",
    modifiers: [{
        name: "offset",
        options: {
            offset: new Int32Array([0, 8]),
        },
    }],
};

createPopper(popcorn, tooltip, settingsjs);

export const popcorn2 = document.querySelector("#popcorn2");

export const tooltip2 = document.querySelector("#tooltip2");

export const settings = PopperOptions__Finalize(PopperOptions__withAddedModifier_174A2785(PopperOptions__withPlacement_Z2582A330(PopperOptions_$ctor(), "right"), PopperModifier__withOptions_4E60E31B(PopperModifier__withName_Z721C83C5(PopperModifier_$ctor(), "offset"), {
    offset: ofArray([0, 8]),
})));

createPopper(popcorn2, tooltip2, settings);

export function Example() {
    let elems_1;
    const patternInput = useFeliz_React__React_useState_Static_1505(null);
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(null);
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(null);
    const ret = usePopper(some(patternInput[0]), patternInput_1[0], PopperOptions__Finalize(PopperOptions__withAddedModifier_174A2785(PopperOptions_$ctor(), PopperModifier__withOptions_4E60E31B(PopperModifier__withName_Z721C83C5(PopperModifier_$ctor(), "arrow"), {
        element: patternInput_2[0],
    }))));
    return createElement("div", createObj(ofArray([["style", {
        paddingTop: 50,
    }], (elems_1 = [createElement("button", {
        type: "button",
        ref: patternInput[1],
        children: "React hook",
    }), createElement("div", createObj(toList(delay(() => append(singleton(["ref", patternInput_1[1]]), delay(() => append(singleton(["style", ret.styles.popper]), delay(() => append((ret.attributes.popper != null) ? collect((matchValue) => singleton([matchValue[0], matchValue[1]]), Object.entries(value_20(ret.attributes.popper))) : empty(), delay(() => {
        let elems;
        return singleton((elems = ["Popper element", createElement("div", {
            ref: patternInput_2[1],
            style: ret.styles.arrow,
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))]));
    }))))))))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
}

render(createElement(Example, null), document.getElementById("react-app"));

